var escape = require("../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../css-loader/index.js??ref--4-oneOf-5-1!../../postcss-loader/src/index.js??postcss!./common.css"), "");

// module
exports.push([module.id, "@font-face {\n\tfont-family: 'Material Symbols Outlined';\n\tfont-style: normal;\n\tfont-display: block;\n\tsrc: url(" + escape(require("./material-symbols-outlined.woff2")) + ") format('woff2');\n}\n\n.material-symbols {\n\tfont-family: 'Material Symbols Outlined';\n}\n", ""]);

// exports
